//	+-----------------------------------------------+
//	| Cardboard UI misc. controller objects			|
//	+-----------------------------------------------+

/**
 * @file cardboard/miscControllers.js
 * @desc This module contains miscellaneous controller objects that aren't big
 * enough for their own files.
 * @author Geoffrey Pursell
 */

/* global workspace, settings */

define('cardboard/miscControllers',[
	// libraries
	"jquery", "underscore", "backbone", "store", "underscore.string", "rsvp", "bowser",

	// app modules
	"cardboard/util", "cardboard/baseController", "cardboard/baseViews"
],
    function ($, _, Backbone, Store, _s, RSVP, Bowser,
        Util, BaseController, Views) {

        console.log("MODULE: cardboard/baseController");

        /**
         * @exports cardboard/miscControllers
         * @desc This module contains miscellaneous controller objects that aren't big
         * enough for their own files.*/
        var MiscControllers = {};

        /**
         * @class
         * @classdesc Provides a map controller
         * @augments module:cardboard/baseController
         */
        MiscControllers.MapController = function () {
            this.initialize.apply(this, arguments);
        };

        Util.inherit(BaseController, MiscControllers.MapController, /** @lends module:cardboard/miscControllers.MapController.prototype */ {
            globalEvents: {
                "map:orgSelected": "onOrgNameSelected",
                "map:request": "onMapRequest",
                "map:orgReset": "onOrgReset"
            },

            // URLs for the map to use
            mapSearchURL: "/cardboard/mapSearch/index.html",

            initialize: function () {
                // convenience properties
                this.$frame = $("#map");
                this.frame = this.$frame[0];
                this.onMap = false;

                // attach declarative global events
                this.attachGlobalEvents();
              // this.attachPrintHandlers();
                this.requestingDataBoxController = null;

                // yeah, handling DOM events is really view-ish stuff, but I don't
                // there's enough need for a separate view obect here.
                $("#closeMap a").on("click", this.onMapCloseButtonClicked.bind(this));

                $(window).on("resize", this.onWindowResize.bind(this));
            },

            attachPrintHandlers: function () {
                var beforePrint = function () {
                    var $chartHolders = $(".chartHolder");
                    $chartHolders.each(function () {
                        var chart = $(this).highcharts();
                        console.log(chart);
                        chart.originalSize = {
                            width: chart.chartWidth,
                            height: chart.chartHeight
                        };
                       chart.innerHTML = chart.axes[0].labelGroup.element.innerHTML;
                        chart.setSize(400, 400, false);
                    });
                };
                var afterPrint = function () {
                    var $chartHolders = $(".chartHolder");
                    $chartHolders.each(function () {
                        var chart = $(this).highcharts();
                        chart.setSize(chart.originalSize.width, chart.originalSize.height, false);
                        chart.axes[0].labelGroup.element.innerHTML = chart.innerHTML;
                        chart.hasUserSize = false;
                    });
                };

                if (window.matchMedia) {
                    var mediaQueryList = window.matchMedia("print");
                    if (mediaQueryList && _.isFunction(mediaQueryList.addListener)) {
                        mediaQueryList.addListener(function (mql) {
                            if (mql.matches) {
                                beforePrint();
                            } else {
                                afterPrint();
                            }
                        });
                    }
                }

                window.onbeforeprint = beforePrint;
                window.onafterprint = afterPrint;
            },


            // ACTIONS
            openMapPage: function (requestingDataBoxView) {
                Backbone.trigger("bubblesShouldClose");
                this.requestingDataBoxController = workspace.getDataBoxControllerFromView(requestingDataBoxView);
                this.loadFrame();
                // we don't really want to do this anymore, it was difficult and
                // useless
                // window.appRouter.navigate("/map", {trigger: false});

                window.workspace.changePage("#page_map");
                this.onMap = true;
            },
            closeMapPage: function (somethingSelected) {
                // tear down the map
                this.killTextFields();
                this.unloadFrame();

                // fuss with URL history
                // if (window.location.href.indexOf("map") !== -1) {
                // 	// if statement here just to be defensive
                // 	window.appRouter.back();
                // }
                window.workspace.changePage("#page_workspace");
                if (somethingSelected) {
                    this.requestingDataBoxController.view.drawerView.close();
                }
                this.onMap = false;
            },
            killTextFields: function () {
                var $map = $("iframe#map"),
                    mapContentWindow = $map.prop("contentWindow"),
                    $mapInputFields = $(mapContentWindow.document).find("input[type=text]");

                // since we're tearing down and rebuilding the maps frame every
                // time, it's okay to just remove the fields. Apparently calling
                // blur() on it doesn't work.
                $mapInputFields.remove();
            },
            testFocus: function () {
                var $map = $("#map"),
                    mapContentWindow = $map.prop("contentWindow"),
                    $mapInputFields = $(mapContentWindow.document).find("input[type=text]");

                setTimeout(function () {
                    $mapInputFields.focus();
                }.bind(this), 1000);
                setTimeout(function () {
                    $mapInputFields.blur();
                }.bind(this), 2000);
            },
            loadFrame: function () {
                // old approach: set the location of an existing iframe
                // this.frame.src = "/Finder";
                // this.frame.contentWindow.location.replace("/Finder");

                // new approach: create the iframe from scratch
                this.$frame = $("<iframe id='map' name='map' scrolling='no' src='" + this.mapSearchURL + "'></iframe>");
                this.frame = this.$frame[0];

                $("#page_map").append(this.$frame);
            },
            unloadFrame: function () {
                this.$frame.remove();
            },


            // UTILITIES

            /** left-pad an org ID with zeroes until it's the proper 9 digits long
             * @param {Object} */
            padOrgId: function (orgId) {
                return _s.pad(orgId, 9, "0");
            },

            /** make sure org ID values we pass along are correct; they sometimes get
             * converted to integers, and we want them to be zero-padded (on the
             * left) strings of exactly 9 characters in length.
             * @param ordId {Object} an org datum
             * @returns {Object} a new copy of the datum object with its orgId
             * properties padded **/
            padOrgIds: function (datum) {
                var newDatum = _.clone(datum);

                newDatum.org = this.padOrgId(datum.org);
                newDatum.orgID = this.padOrgId(datum.orgID);
                newDatum.wfOrgID = this.padOrgId(datum.wfOrgID);

                return newDatum;
            },


            // EVENT HANDLERS

            onMapCloseButtonClicked: function () {
                this.closeMapPage();
            },

            onMapRequest: function (data) {
                this.openMapPage(data.requestingDataBoxView);
            },

            onOrgNameSelected: function (datum) {
                if (datum.org) {
                    var orgFinderView = this.requestingDataBoxController.view.drawerView.orgFinderView;

                    this.closeMapPage(true); // true means sw should close th drawer, also
                    orgFinderView.setOrgFromMap(this.padOrgIds(datum));

                }
            },
            /** @event orgChanged */
            onOrgReset: function (data) {
     
                var orgFinderView = data.requestingDataBoxView;

                var datum = {
                    name: "Statewide",
                    orgID: "999999000",
                    groupType: "state"
                };

                orgFinderView.setOrg(datum);
            },
            onWindowResize: function ( /*event*/ ) {
                //$("#navDrawer").panel("close");    // Closing on resize seems to trigger always on mobile
            }
        });



        /**
         * @class
         * @classdesc Provides an object to manage global settings and the settings
         * dialog
         * @augments module:cardboard/baseController
         */
        MiscControllers.Settings = function () {
            this.initialize.apply(this, arguments);
        };

        Util.inherit(BaseController, MiscControllers.Settings, /** @lends module:cardboard/miscControllers.Settings.prototype */ {
            globalEvents: {
                "globalSettings:changed": "onSettingChanged"
            },
            defaultSettings: {
                "debugMode": "off",
                "animation": "on",
                "maxBoxes": 4,
                "helpBubbles": "on"
            },
            // "debug"
            magicKeys: [100, 101, 98, 117, 103],


            initialize: function () {
                /** a jQuery for the config window
                 * @type Views.DataBoxView */
                var $dialog = this.$dialog = $("#page_settings");

                // the "if" is just so this can be executed from the unit test. I
                // know, I know, separation of view and business logic. This time I
                // did the bad thing.
                if ($dialog.popup) {
                    $dialog.popup({
                        tolerance: "60,40,40,40",
                        positionTo: "origin",
                        transition: "pop"
                    });
                }
                $dialog.trigger("create");
                this.$form = $dialog.find("form").first();

                this.initAppDefaults();
                if (this.$form.length) {
                    this.initFormElements();
                }

                // attach declarative events
                this.attachGlobalEvents();

                // DOM event bindings
                $dialog.on("change", "select, input", this.onUserSetGlobalSetting.bind(this));
                $dialog.on("keypress", this.onKeyPress.bind(this));
                $dialog.on("click", ".close.ui-btn", this.onDialogCloseButtonClicked.bind(this));

                var $langDialog = this.$langDialog = $("#lang_select");

                // the "if" is just so this can be executed from the unit test. I
                // know, I know, separation of view and business logic. This time I
                // did the bad thing.
                if ($langDialog.popup) {
                    $langDialog.popup({
                        tolerance: "40,40,40,40",
                        positionTo: "origin",
                        transition: "pop"
                    });
                }
                $langDialog.trigger("create");
                this.$form = $langDialog.find("form").first();

                this.initAppDefaults();
                if (this.$form.length) {
                    this.initFormElements();
                }

                // attach declarative events
                this.attachGlobalEvents();

                // DOM event bindings
                $langDialog.on("change", "select, input", this.onUserSetGlobalSetting.bind(this));
                $langDialog.on("keypress", this.onKeyPress.bind(this));
                $langDialog.on("click", ".close.ui-btn", this.onDialogCloseButtonClicked.bind(this));

                // for "debug" key sequence detection
                this.charBuffer = [];
            },

            // EVENT HANDLERS
            onUserSetGlobalSetting: function (event) {
                var control = event.target;
                this.set(control.name, control.value);
            },
            onDialogCloseButtonClicked: function (event) {
                window.workspace.changePage("#page_workspace");
                event.preventDefault();
            },
            onSettingChanged: function ( /*settingInfo*/ ) {},
            // ACTIONS
            openSettingsDialog: function (event) {
                // if (event) { event.preventDefault(); }
                // window.workspace.changePage("#page_settings", { role: "dialog" });
                // this.$dialog.popup("open");
            },
            initFormElements: function () {
                // this.openSettingsDialog();
                // load up form defaults
                _(Store.getAll()).each(function (value, key) {
                    var $element = $(this.$form[0][key]);
                    if ($element.length) {
                        if ($element.attr("data-role") === "flipswitch") {
                            // on/off switches!
                            $element.attr("value", value);
                        } else if ($element.attr("data-type") === "range") {
                            // sliders!
                            $element.val(value);
                            $element.slider("refresh");
                        }
                    }
                }.bind(this));
            },
            initAppDefaults: function () {
                // load up form defaults
                _(this.defaultSettings).each(function (value, key) {
                    // if there's no setting there already, throw in the
                    // default.
                    if (!this.get(key)) {
                        this.set(key, value);
                    }
                }.bind(this));
            },

            // these take settings names without the "setting_" prefix
            get: function (name) {
                return Store.get(this.prefixSettingName(name));
            },
            set: function (name, value) {
                try {
                    var prefixedName = this.prefixSettingName(name),
                        oldValue = this.get(prefixedName);

                    Store.set(prefixedName, value);

                    Backbone.trigger("globalSettings:changed", {
                        name: this.stripSettingName(name),
                        value: value,
                        oldValue: oldValue
                    });
                } catch (error) {
                    // likely, the user is in private browsing mode or some other
                    // scenario in which local storage is forbidden.
                    console.log("Error setting config value.");
                    console.log(error);
                }
            },
            remove: function (name) {
                Store.remove(this.prefixSettingName(name));
            },

            // UTILITIES
            stripSettingName: function (settingName) {
                return settingName.replace(/^setting_/, "");
            },
            prefixSettingName: function (settingName) {
                if (/^setting_/.test(settingName)) {
                    return settingName;
                }
                return "setting_" + settingName;
            },

            // DOM EVENT HANDLERS
            onKeyPress: function (event) {
                var charCode = event.charCode,
                    max = this.magicKeys.length;

                // push the keystrokes onto the buffer
                this.charBuffer.push(charCode);
                if (this.charBuffer.length > max) {
                    this.charBuffer.shift();
                }
                // see if the arrays are equal
                if (this.charBuffer.toString() === this.magicKeys.toString()) {
                    $(document.body).toggleClass("devMachine");
                }
            }
        });

        /**
         * @class
         * @classdesc Provides a controller object to manage the databox adder
         * @augments module:cardboard/baseController
         */
        MiscControllers.DataBoxAdder = function () {
            this.initialize.apply(this, arguments);
        };

        Util.inherit(BaseController, MiscControllers.DataBoxAdder, /** @lends module:cardboard/miscControllers.DataBoxAdder.prototype */ {
            globalEvents: {
                "globalSettings:changed": "update"
            },

            initialize: function () {
                // attach declarative events
                this.attachGlobalEvents();
                this.view = new Views.DataBoxAdder();
                this.view.on("addDataBox", this.onAddDataBox);
                this.view.render();
            },

            onAddDataBox: function () {
                // trigger our own even so the main workspace controller
                // that created us can do its thing
                Backbone.trigger("addDataBox");

                // URL updating now done by the workspace controller, because it
                // needs to wait until after the filters have loaded to do it
                // properly
                //window.workspace.updateWorkspaceURL();
            },

            update: function () {
                if (workspace.boxCount() >= settings.get("maxBoxes")) {
                    this.disable();
                } else {
                    this.enable();
                }
            },
            disable: function () {
                this.view.$el.addClass("maxedOut");
            },
            enable: function () {
                this.view.$el.removeClass("maxedOut");
            }
        });

        /**
         * @class
         * @classdesc Handles the different content views around the page. 
         * @augments module:cardboard/baseController
         */
        MiscControllers.DynamicTextController = function () {
            this.initialize.apply(this, arguments);
        };

        Util.inherit(BaseController, MiscControllers.DynamicTextController, {
            initialize: function (options) {
                this.options = options;
                this.replaceStaticElements();
            },
            // Some of our tags are in markup
            replaceStaticElements: function () {
                // Do a lookup for all the places where text will be replaced in the DOM
                this.dynamicContainers = $('[data-dynamiccontent]');
                _(this.dynamicContainers).each(function (el, i) {
                    var $contentArea = $(el),
                        //get the associated content
                        contentArray = this.contentModelLookup($contentArea.data('dynamiccontent'))
                        //Loop the internal places we need to replace
                    _($contentArea.find('[data-dynamickey]')).each(function (inner, i) {
                        var $inner = $(inner);
                        $inner.html(function () {
                            //if there is a key, use it
                            if ($inner.attr('data-dynamickey')) {
                                return contentArray[$(inner).attr('data-dynamickey')];
                            } else { //else assume it's an array
                                return contentArray[i];
                            }
                        });
                    });
                }, this);
            },
            contentModelLookup: function (key) {
                var model = this.options.collection.findWhere({
                    "area": key
                });
                try {
                    return model.get('content')
                } catch (e) {
                    console.log("'" + key + "' doesn't look like a model. Is there a matched data-dynamiccontent attr?", e)
                    return false
                }
            }
        });

        return MiscControllers;
    });
